//
// AlertableElement.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./MediaType";
import "./particles/AlertStrategy";
import "./particles/AlertInterval";
import "@sas-dvr/ltjs-commons/models/particles/Link";

var AlertableElement = createModule("transport::AlertableElement", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel","transport::MediaType"], EventDispatcher, [
    ,
    {
        clause: 7,
        subscribed: 2,
        alertName: 7,
        evaluationStrategy: 4,
        intervalUnit: 4,
        evaluationInterval: 4,
        links: [1],
        label: 7,
        visualElement: 7,
        id: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default AlertableElement;
